const AgeBanner = () => {
    return (
        <div className="age-banner">
            <span>18+ ONLY | VIRTUAL CREDITS | NO CASH VALUE</span>
        </div>
    )
}

export default AgeBanner